export default __webpack_public_path__ + "static/media/ufc-store.49aa53bd.png";